import styled from 'styled-components'
import { getStepDividerStyles, StepStatus } from '../style'
import { StepperSize } from '../type'

interface StyledStepDividerProps {
    status: StepStatus
    size?: StepperSize
}

const StyledStepDivider = styled.div.withConfig({
    shouldForwardProp: (prop) => !['status', 'size'].includes(prop)
})<StyledStepDividerProps>(({ theme, status, size = 'md' }) =>
    getStepDividerStyles({ theme, status, size })
)

export default StyledStepDivider
